import React from "react";

const SubscribedBusiness = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.667 5.16663H14.667V9.16663"
        stroke="#6A6A6A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.6663 5.16663L8.99967 10.8333L5.66634 7.49996L1.33301 11.8333"
        stroke="#6A6A6A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default SubscribedBusiness;
